
const awsExports = {
  Auth: {
      Cognito: {
          region: "ap-south-1", //AWS region
          userPoolId: "ap-south-1_zhpEHoSe5", // User Pool ID
          userPoolClientId: "90n22vre364u6pqo617ghr6sf", // App Client ID
          aws_cognito_identity_pool_id : "ap-south-1:7764ba92-dc65-4657-9ab9-dd6d187969aa", // Identity Pool ID
          mandatorySignIn: true,
          redirect_uri: "https://vic.kpoint.ai/?tag=icici_pru",
          scope: "email openid", 
          passwordFormat: {
            minLength: 8,
            requireLowercase: true,
            requireUppercase: true,
            requireNumbers: true,
            requireSpecialCharacters: true,
          },
          loginWith: {
            email: true,
          },
          signUpVerificationMethod: "username",
        }
  },
};

export default awsExports;